<!--
* UIID: 
* UI Name: Folder List
* Modify Date: 2020/10/07
-->
<template>
  <v-card height="100%" class="folder-card-section">
    <v-card-text>
      <v-row class="custom-form-control">
        <v-col cols="12" md="3" lg="2" class="pt-0 pb-0">
            <div class="title-grid-folder">
            <v-label class>{{$t('lbl.mapBuilder.loadFile.fileSection')}}</v-label>
          </div>
        </v-col>
        <!-- Search control -->
        <v-col
          cols="12"
          md="9"
          lg="10"
          class="comm-header-col date-query-section pt-0 pb-0 text-right"
        >
          <div class="d-inline-flex">
            <v-text-field
              v-model="searchName"
              append-icon="fa fa-search"
              placeholder="Find by file name"
              hide-details
              dense
              solo
              class="search-button mt-0"
              height="30"
            ></v-text-field>
          </div>
          <div class="d-inline-flex">
            <v-select
              label="Type"
              v-model="searchType"
              :items="statusList"
              hide-details
              dense
              solo
              class="custom-selectbox"
              :menu-props="{offsetY: true,}"
            ></v-select>
          </div>
          <div class="mr-0 d-inline-flex btn-control">
            <v-btn class="btn btn-search" color="primary">
              <v-icon x-small class="mr-2">fa fa-plus</v-icon>Add File
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <!-- Grid table page class="flat-file-control-section" -->
      <v-row>
        <v-col class="page-control-content page-control-bg folder-pagination">
          <v-row>
            <v-col lg="12" md="12">
              <v-row>
                <v-col class="page-control-bg" cols="12">
                  <div class="page-showing">
                    <v-label>{{$t('lbl.common.showing')}} {{this.itemsPerPage}} {{$t('lbl.common.of')}} {{this.listData.length}}</v-label>
                  </div>
                  <div class="custom-pagi-selectbox">
                    <v-select
                      v-model="itemsPerPage"
                      hide-details
                      dense
                      solo
                      :items="itemShow"
                      class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox"
                    ></v-select>
                  </div>
                  <div class="page-count flat-table-pagination">
                    <v-pagination v-model="page" :length="Math.ceil(listData.length/itemsPerPage)"></v-pagination>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!-- File Detail -->
      <v-row class="grid-file-view ml-0 mr-0 file-view-wrap">
         <v-col cols="12" md="4" lg="2" class="pt-0" v-for="item in dataPaginated" :key="item.ROWID" v-show="(searchType==''||searchType==item.USR_FILE_TYPE) && findSearchFile(item)">
          <fileDetail :detail="item"></fileDetail>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>


<script>
import fileDetail from "@/vue-caas/views/folder/FileDetail.vue";

export default {
  components: {
    fileDetail
  },

  props: {
    items: {
      default: Array
    },
    listData:{
      default: Array
    },
    resetPage:{
      default: String
    }
  },

  data: () => ({
    // listData: Array,
    itemsPerPage:24,
    page: 1,
    perPage: 24,
    insertItem: {
      partner: "",
      contract: "",
      email: "",
      email_f: "",
      email_t: "",
      status: "",
      remark: ""
    },
    searchType: "",
    searchName: "",
    statusList: [
      { text: "All", value: "" },
      { text: "txt", value: "txt" },
      { text: "cpp", value: "cpp" },
      { text: "json", value: "json" },
      { text: "xml", value: "xml" },
      { text: "biz", value: "biz" }
    ],
    inputDisplay: "d-none",
    itemShow:[
      {text:"Show 24" , value:24},
      {text:"Show 36" , value:36},
      {text:"Show 60" , value:60},
      {text:"Show 90" , value:90},
      {text:"Show 120" , value:120}
    ],
  }),
  computed: {
     dataPaginated () {
       return this.paginate(this.listData, this.itemsPerPage , this.page)
    } 
  },
  watch: {
    resetPage:{
      immediate:true,
      handler(){
        this.page=1;
      }
    }
  },

  created() {
    // this.listData = this.items;
  },
  methods: {
    paginate(array, page_size, page_number) {
      return array.slice((page_number - 1) * page_size, page_number * page_size);
    },
    findSearchFile(item) {
        if(this.searchName != '') {
          // for(let key in item) {
          if(item['USR_FILE_NAME'].toLowerCase().indexOf(this.searchName.toLowerCase()) > -1) {
            return true;
          }
          return false;
        } else {
          return true;
        }
      },
  }
};
</script>